import { v4 as uuidv4 } from 'uuid';
import precision from '../assets/projects/precision.webp';
import rufin from '../assets/projects/rufin.webp';
import raamp from '../assets/projects/raamp.webp';
import maize from '../assets/projects/maize.webp';
import ditra from '../assets/projects/ditra.webp';
import aedp from '../assets/projects/aedp.webp';
import coconut from '../assets/projects/coconut.webp';
import vivr from '../assets/projects/vivr.webp';
import rice from '../assets/projects/rice.webp';
import akfims from '../assets/projects/akfims.webp';
import vam from '../assets/projects/vam.webp';

const PROJECTS = [
  {
    id: uuidv4(),
    img: precision,
    theme: "IMPACT OF PRECISION AGRICULTURE AND TRADITIONAL AGRICULTURE ON AFRICA'S FOOD SYSTEMS",
    overview: [
      'The social circumstances and technological environment indicate that several phases of the supply chains will be more receptive to Precision/Digital Agriculture adoption and deployment than others, leading to the interest of the project. El-kanis and Partners and Faculty of Agriculture, University of Uyo intend to explore the subject to research on the costs benefit analysis of Precision/Digital Agriculture and traditional agriculture, a development that will contribute to the benefit of creating an Africa that is properly fed.',
      'The partnership will be contributing to the project for more efficient, climate resilient and sustainable agricultural production and efficient food systems to enhance food security, incomes, and nutrition that benefit small-scale farmers (particularly women and the youth).  There are a number of reasons for creating Precision/Digital Agriculture research network in the context of Africa food security. These include:',
    ],
    action: [
      'using the report as a means of organizing and sharing information;',
      'undertaking joint activities such as collaborative research;',
      'working towards common goals.',
    ],
    result: [
      'To deepen understanding of how to develop and scale sustainable African agriculture and food system leveraging Precision/Digital Agriculture innovations;',
      'To build the capacity of African innovators and researchers to develop, deploy and scale such Precision/Digital Agriculture applications; and',
      'To facilitate the contribution of African research to relevant international Precision/Digital Agriculture policy and practice conversations.',
    ],
    subtitle: 'Key areas the project will leverage digital Agriculture in support of agricultural and food systems innovations are;',
    areas: [
      'Detection and diagnostics of plant diseases and pests,',
      'Modeling soil physicochemical properties and composition,',
      "Supporting farmers' choices in crop cultivation through the analysis of data collected and transmitted by sensors,",
      'Targeting food-insecure populations,',
      'Detecting real-time outbreaks of food-borne diseases,',
      'Recognizing and assessing risks to yields under warmer temperatures and climate variability,',
      'Simulating future yield performance in different environments, and',
      'Identifying improved agricultural management practices',
    ],
    duration: '2022 - 2027',
    more: '',
  },
  {
    id: uuidv4(),
    img: rufin,
    theme: 'RURAL FINANCE INSTITUTIONS-BUILDING PROGRAMME (RUFIN)',
    overview: [
      'The overall goal of RUFIN was to reduce poverty, particularly among the rural poor and especially women, youth and the physically challenged.',
    ],
    action: [],
    result: [
      'To develop and strengthen rural financial services and enhance the accessibility of poor rural people to these services so as to expand production; and',
      'Improve the productivity of agriculture and micro-small rural enterprises. programme aim at improving livelihoods and living conditions of at least 40,000 rural families in Akwa Ibom.',
      'The programme was refocused to embark on enterprises to directly impact on productivity, build up the agriculture value chain, create jobs, generate income and reduce poverty in a tangible manner.',
    ],
    subtitle: '',
    areas: [],
    duration: '',
    more: '<a href="https://dailytrust.com/7yrs-of-rufin-project-fg-ifad-review-impact-on-rural-farmers/" target="_blank">RUFIN Project</a>',
  },
  {
    id: uuidv4(),
    img: raamp,
    theme: 'AKWA IBOM STATE RURAL ACCESS AND AGRICULTURAL MARKETING PROJECT (RAAMP)',
    overview: [
      'We worked as part of the Sub-contractor on the project for the State Government to support the improvement of Agro-logistics Activities for Agro-logistics performance enhancement activities. This included support to farms and cooperatives to reduce post-harvest losses and support to the small and medium-sized enterprises (SMEs) at the agro-logistics centers and market users.',
    ],
    action: [],
    result: [
      'Enhanced Market Access and Business Linkages: the project will multiply business linkages to facilitate development of markets that are more inclusive, dynamic and functional. Building the capacity of market actors will increase market preparedness and ensure producer organizations can meet quality and quantity buyer requirements.',
      'Improved Access to and Use of Quality and Affordable Inputs and Services: the project work at the input supply system-level to reduce costs, improve quality, increase access and raise awareness among producers on the effective and efficient use of inputs and agricultural services at the farm and firm levels.',
    ],
    subtitle: '',
    areas: [],
    duration: '',
    more: '<a href="https://www.akwaibomraamp.org/" target="_blank">Akwa Ibom State RAAMP</a>',
  },
  {
    id: uuidv4(),
    img: maize,
    theme: 'ODUKPANI MAIZE OUTGROWER PROJECT',
    overview: [
      'Maize farming project developed by El-kanis were we mapped, conduct soil analysis and digitize 500 hectares of maize fields in Odukpani Local government areas of Cross River State. The project provided extension services and inputs to maize farmers at project sites. The overall goal was to encourage farmers to plant above what they can consume. We created market linkages to facilitate trade relationship between farmers and the external market and processors.',
    ],
    action: [],
    result: [
      'The project enable 4,000 maize farmers to raise their income from N179,000 to N410,000 per hectare per season, thus, strengthening their resilience, promoting inclusive rural economic development and creating indirect employment to over 15,000 workers.',
      'The commodity-specific initiatives explicitly aim to bolster economic growth and ensure the sustainable use of terrestrial ecosystems (to increase agricultural productivity)). Investments in value chains for maize, and production systems for target women producers and youth as beneficiaries.',
    ],
    subtitle: '',
    areas: [],
    duration: '',
    more: '',
  },
  {
    id: uuidv4(),
    img: ditra,
    theme: 'DIGITAL INTERVENTION FOR TRANSFORMATION OF RURAL AGRICULTURE (DITRA)',
    overview: [
      'DITRA supports smallholder farmers with technical and digital services to improve their agricultural productivity, facilitate improvements in quality and yield, build communities’ productive base and increase the supply of inputs to farmers, while enhancing livelihood and socio-economic activities of rural communities.',
    ],
    action: [],
    result: [
      'Strengthening the capacities of smallholder farmers by connecting seed producers and other Agro- support services providers to farmers to enhance massive penetration and cultivation of staple crops, build resilience',
      "Facilitate access to markets, including facilitating safe transport, and working to ensure markets remain open and that demand for farmers' produce remains high.",
      'Deliver up-to-date agriculture-related information to smallholder producers on production, weather, market prices and other important areas in rural areas through digital services.',
      'Building trade capacities through provision of technologies and services that enable smallholder producers to meet quality and sanitary standards of overseas markets.',
    ],
    subtitle: '',
    areas: [],
    duration: '',
    more: '',
  },
  {
    id: uuidv4(),
    img: aedp,
    theme: 'AKWA IBOM AGRICULTURAL DEVELOPMENT PROGRAMME -AGRIBUSINESS ENTERPRISE DEVELOPMENT PROGRAM (AEDP)',
    overview: [
      'This programme is designed to accelerate the production of staple food (maize, rice, onions and cassava) in Akwa Ibom State with the involvement of 10,000 smallholder farmers and mapping of 6,000 hectares of farmland. Farmers are supported with inputs, trained on Good Agronomic Practice, Sustainable Agriculture, Food Safety, Packaging, Processing Labeling and Branding',
    ],
    action: [],
    result: [
      '10,000 individuals applying improved agricultural management practices or technologies with Akwa Ibom Government assistance.',
      'Participants are expected to apply lessons learn on their farms which is expected to build their resilience and livelihoods',
    ],
    subtitle: '',
    areas: [],
    duration: '',
    more: '<a href="https://factsreporter.com.ng/2020/11/03/aedp-raises-the-bar-in-agricultural-drive-food-sufficiency/" target="_blank">AEDP Project</a>',
  },
  {
    id: uuidv4(),
    img: coconut,
    theme: 'OKOBO COCONUT FARM ESTATE PROJECT DEVELOPMENT',
    overview: [
      'We were hired by Akwa Ibom State Ministry of Agriculture to map, conduct soil analysis and digitize 500 hectares of coconut plantation in Okobo Local government areas of Akwa Ibom State.',
    ],
    action: [],
    result: [
      'Detection and diagnostics of plant diseases and pests',
      'Modeling soil physicochemical properties and composition,',
      "Supporting Government's choices in coconut cultivation through the analysis of data collected and transmitted by sensors,",
      'Simulating future yield performance in different environments, and',
      'Identifying improved agricultural management practices',
    ],
    subtitle: '',
    areas: [],
    duration: '',
    more: '<a href="https://businessday.ng/news/article/udom-launches-coconut-planting-campaign/" target="_blank">Governor Udom launches coconut farming</a>',
  },
  {
    id: uuidv4(),
    img: vivr,
    theme: 'EL-KANIS VERNACULAR INTERACTIVE VOICE RESPONSE PLATFORM (EIVR)',
    overview: [
      'El-kanis Vernacular Interactive Voice Response Platform (EIVR) is a mobile telephony system that supports information dissemination in local dialect between agro-service providers and rural famers for sustainable land management practices increase in food production and resilience to climate extremes. These strengthen rural food production and poverty/hunger reduction amongst poor farmers.',
    ],
    action: [],
    result: [
      "Improved communication between rural farmers and agencies, via EIVR option that will provide accurate, up-to-date information and answering farmers' questions, these focal points could help represent rural farmers' needs and concerns",
      'The platform will strengthen the capacity of extension service providers to communicate effectively with rural farmers and also support relevant government bodies to communicate effectively with rural farmers through EIVR option.',
      "EIVR option will help agencies to increase their understanding of rural farmers, and help to develop effective communication and support strategies according to farmers' profiles, needs and sensitivities.  Adoption of EIVR will lead to at least 15% rise in farm income by direct consumer connection to rural farmers, stability of incomes from better demand visibility, while consumers will get better produce and prices.",
    ],
    subtitle: '',
    areas: [],
    duration: '',
    more: '<a href="https://enews.com.ng/el-kanis-launches-e-platform-to-disseminate-information-to-farmers-in-aibom" target="_blank">El-kanis launches e-platform to disseminate information to farmers in A’Ibom</a>',
  },
  {
    id: uuidv4(),
    img: rice,
    theme: 'INI RICE OUTGROWER PROJECT',
    overview: [
      "An outgrower project developed by El-kanis and Partners with 8,460 farmers currently on the project and cultivating 5,200 hectares of rice. We're estimating over 18,000 mt of rice paddy at project completion.",
    ],
    action: [],
    result: [
      '8,460 smallholders and entrepreneurs applying improved technical and business management practices or technologies using improved variety.',
      '8,460 farmers reached through project activities and increased their income by 20%',
      '18,800 individuals will indirectly benefit from the project.',
    ],
    subtitle: '',
    areas: [],
    duration: '',
    more: '',
  },
  {
    id: uuidv4(),
    img: akfims,
    theme: 'AKWA IBOM FARMERS INFORMATION MANAGEMENT SYSTEM (AKFIMS)',
    overview: [
      'Elkanis was the project consultant and Developers for the Akwa Ibom Farmers and Information Management System Project. We hired 5,000 enumerators who enumerated and profiled 300,000 farmers and agribusiness owners, using EL-kanis Open Data Kit Mobile Application for data collection, stored in a cloud server.',
    ],
    action: [],
    result: [
      'The information and enterprise management system software was developed with the aim of managing the enumerated farmers and creating linkages between anchor companies involved in the processing and small holder farmers (SHFs). The platform provides farm inputs in kind and cash (for farm labour) to small holder farmers to boost production of these commodities.',
    ],
    subtitle: '',
    areas: [],
    duration: '',
    more: '<a href="https://independent.ng/post-covid-economy-akwa-ibom-digitalizes-farming-for-agribusiness/" target="_blank">Post-COVID Economy: Akwa Ibom Digitalizes Farming For Agribusiness</a>',
  },
  {
    id: uuidv4(),
    img: vam,
    theme: 'REGULATORY REVIEW NIGERIA, FOOD LABELING AND MARKETING PROVISIONS FOR NUTRIENT ENRICHED CROPS, VITAMIN A MAIZE (VAM) AND VITAMIN A CASSAVA (VAC)',
    overview: [
      "The project was awarded to El-kanis and Partners and is part of the partnership with <a href='https://www.harvestplus.org' target='_blank'>HarvestPlus</a> and <a href='https://www.gainhealth.org' target='_blank'>GAIN</a> for the  <a href='https://www.harvestplus.org/gain-harvestplus-launch-commercialisation-of-biofortified-crops-programme-in-nigeria/#:~:text=The%20Global%20Alliance%20for%20Improved,in%20Africa's%20most%20populous%20country' target='_blank'>Commercialization of Biofortified Crops (CBC) project</a>. The main objective was to establish the current regulatory frameworks and food industry guidelines on the marketing of biofortified grains, biofortified flour and foods made from biofortified ingredients.<br> This information will be used to create guidelines documents created for businesses involved in biofortification. It will also be used to identify authorities involved in the creation and endorsement of new standards and regulations in this area.",
    ],
    action: [],
    result: [
      'This report will be used to create a guide for primary producers: how to procure, store, process, store processed food, sell and market VAM and VAC.',
      'To Provide technical support to medium and large scale VAM producers in target LGAs: Guidelines for manufacturers in the sale and marketing of foods made from VAM.',
      'To identify the stakeholders of interest for the introduction of new standards for the nutrient levels in VAC grain and VAC roots.',
    ],
    subtitle: '',
    areas: [],
    duration: '',
    more: '',
  },
];

export default PROJECTS;
